import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { prepList as initialPrep } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiCheckSquare, FiSquare } from 'react-icons/fi';

export const PrepList = () => {
  const [items, setItems] = useState(initialPrep);

  const toggleStatus = (id) => {
    setItems(items.map(item => {
      if (item.id === id) {
        return { ...item, status: item.status === 'completed' ? 'pending' : 'completed' };
      }
      return item;
    }));
  };

  return (
    <Card title="Kitchen Prep Lanes" className="col-span-1">
      <div className="space-y-3">
        {items.map(item => (
          <div 
            key={item.id} 
            className={`flex items-center gap-3 p-3 rounded border transition-colors cursor-pointer
              ${item.status === 'completed' ? 'bg-chefBlack border-chefBlack opacity-50' : 'bg-chefPanel border-chefPanel hover:border-receiptWhite/20'}
            `}
            onClick={() => toggleStatus(item.id)}
          >
            <SafeIcon 
              icon={item.status === 'completed' ? FiCheckSquare : FiSquare} 
              className={`w-5 h-5 ${item.status === 'completed' ? 'text-status-open' : 'text-receiptMuted'}`}
            />
            <div className="flex-1 min-w-0">
              <div className={`text-sm font-medium ${item.status === 'completed' ? 'text-receiptMuted line-through' : 'text-receiptWhite'}`}>
                {item.item}
              </div>
              <div className="text-xs text-receiptMuted flex gap-2 font-mono mt-1">
                <span className="text-chiliRed">{item.station}</span>
                <span>•</span>
                <span>{item.qty}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};